export const debounce = (func: () => void) => {
  var timer: any;
  return function (event: unknown) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, 200, event);
  };
};
